import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
  button: (props: any) => ({
    position: "fixed",
    bottom: props.matches ? "2rem" : props.isInProduct ? "4rem" : "1rem",
    right: props.matches ? "2rem" : "1rem",
    display: props.hidden ? "none" : "flex",
    justifyContent: "center",
    alignItems: "center",
    width: props.matches ? "3rem" : "3rem",
    height: props.matches ? "3rem" : "3rem",
    backgroundColor: theme.whiteColor,
    opacity: 0.6,
    borderRadius: "50%",
    border: `1px solid ${theme.darkSlateGrayColor}`,
    cursor: "pointer",
    outline: "none",
    fontFamily: theme.fontFamilyQuestrial,
    "&:hover": {
      backgroundColor: theme.snowColor,
    },
  }),
}));

export default useStyles;
